export default import.meta.ROLLDOWN_FILE_URL_DhCmwlGQbWmHGSkti_$C0A